import type { MultiPrimaryItem } from '@/components/Form/FormAutocompleteField/MultiPrimaryAutocompleteField';
import type { LocalSpecialty } from '@/core/graphql/generated/types';

export const mapLocalSpecialtiesIn = (
	localSpecialties: LocalSpecialty[] | undefined
): MultiPrimaryItem[] => {
	if (!localSpecialties?.length) return [];
	return localSpecialties.map(s => ({ id: s.code, name: s.name }));
};
